import { Text, View } from "@react-pdf/renderer";

const AboutTech = ({ styles, techData, date }) => {
  return (
    <View style={styles.about}>
      <View style={{ ...styles.left, paddingLeft: "5px" }}>
        <Text>Termovent-komerc d.o.o </Text>
        <Text style={styles.address}>Kneza Miloša 88a</Text>
        <Text style={{ ...styles.address, marginBottom: "5px" }}>
          Skyline, 1. floor, 11000 Belgrade, Serbia
        </Text>
        <View style={styles["left-sm-flex"]}>
          <Text style={styles.label}>Email: info@termovent.rs</Text>
          <Text style={styles.value}>Tel: +381 11 3087404</Text>
        </View>
        <View style={styles["left-sm-flex"]}>
          <Text style={styles.label}>Web: www.termovent.com</Text>
          <Text style={styles.value}>Fax: +381 11 2413544</Text>
        </View>
        <View style={styles["left-sm-flex"]}>
          <Text style={styles.label}>User:</Text>
          <Text style={styles.value}>
            <b>{techData.user}</b>
          </Text>
        </View>
      </View>
      <View style={{ ...styles.right, paddingRight: "5px" }}>
        <View style={styles["md-flex"]}>
          <Text style={styles.label}>Project:</Text>
          <Text style={styles.value}>
            <b>{techData.project}</b>
          </Text>
        </View>
        <View style={styles["md-flex"]}>
          <Text style={styles.label}>Location:</Text>
          <Text style={styles.value}>
            <b>{techData.location}</b>
          </Text>
        </View>
        <View style={styles["md-flex"]}>
          <Text style={styles.label}>System:</Text>
          <Text style={styles.value}>
            <b>{techData.system}</b>
          </Text>
        </View>
        <View style={styles["md-flex"]}>
          <Text style={styles.label}>Revision:</Text>
          <Text style={styles.value}>
            <b>{techData.revision}</b>
          </Text>
        </View>
        <View style={styles["md-flex"]}>
          <Text style={styles.label}>Date:</Text>
          <Text style={styles.value}>
            <b>{date}</b>
          </Text>
        </View>
      </View>
    </View>
  );
};

export default AboutTech;
